import * as _ from "lodash";
import * as types from './action-types';
//import { type } from "os";
import { IQaRegistrationState } from "./state";

var initialState: IQaRegistrationState = {
    QaRegistrationSteps: [],
    QaPwlSteps: [],
    StepUrl: ""
}

export const Reducer = (state: IQaRegistrationState = initialState, action: any) => {
    let s = _.cloneDeep(state);
    switch (action.type) {
        case types.SET_GETREGISTRATIONSTEPS:
            s.QaRegistrationSteps = action.QaRegistrationSteps;
            return s;

    }

    return s;
}